export const getTenantTZ = () => localStorage.getItem('tenantTimezone') || 'Asia/Jakarta';
export const setTenantTZ = (tz) => { if (tz) localStorage.setItem('tenantTimezone', tz); };

const _toAbsDate = (v) => {
  if (v == null) return new Date(NaN);
  if (typeof v === 'number') return new Date(v > 1e12 ? v : v * 1000);
  const s = String(v);
  if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}/.test(s) && !/[zZ]|[+\-]\d{2}:?\d{2}$/.test(s)) return new Date(s + 'Z');
  return new Date(v);
};

export const fmtDatetime = (v, fallback = '-') => {
  if (!v) return fallback;
  try {
    const d = _toAbsDate(v); if (isNaN(d)) return fallback;
    return d.toLocaleString('id-ID', { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit', timeZone: getTenantTZ() });
  } catch { return fallback; }
};

export const fmtDatetimeFull = (v, fallback = '-') => {
  if (!v) return fallback;
  try {
    const d = _toAbsDate(v); if (isNaN(d)) return fallback;
    return d.toLocaleString('id-ID', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit', timeZone: getTenantTZ() });
  } catch { return fallback; }
};

export const fmtDateShort = (v, fallback = '-') => {
  if (!v) return fallback;
  try {
    const d = _toAbsDate(v); if (isNaN(d)) return fallback;
    return d.toLocaleDateString('id-ID', { day: '2-digit', month: 'short', year: 'numeric', timeZone: getTenantTZ() });
  } catch { return fallback; }
};

export const fmtMonthYear = (v, fallback = '-') => {
  if (!v) return fallback;
  try {
    const d = _toAbsDate(v); if (isNaN(d)) return fallback;
    return d.toLocaleDateString('id-ID', { month: 'long', year: 'numeric', timeZone: getTenantTZ() });
  } catch { return fallback; }
};

export const fmtClock = (date) => {
  try {
    const d = date instanceof Date ? date : new Date(date);
    return new Intl.DateTimeFormat('id-ID', { hour: '2-digit', minute: '2-digit', second: '2-digit', timeZone: getTenantTZ() }).format(d);
  } catch { return '--:--:--'; }
};
